/* Copyright (c) 2025 Xperi. All Rights Reserved.  */

import { useMemo } from 'react';

import { DeviceModel } from '../../../../../core/device';
import { DateTime } from '../../../../../core/utils';

import './FilteredGuideTableHeader.scss';

interface IFilteredGuideTableHeaderProps {
    category: string;
    firstChannelStartTime: number | undefined;
}

const FilteredGuideTableHeader = ({
    category,
    firstChannelStartTime,
}: IFilteredGuideTableHeaderProps): JSX.Element => {
    const gridHeaderCellDate = useMemo(() => {
        const validStartTime = firstChannelStartTime || Date.now();
        const dateTime = new DateTime(validStartTime);
        return dateTime
            .toLocaleDayWithDate(DeviceModel.getTVProperties().getLang())
            .replace('.', '');
    }, [firstChannelStartTime]);

    return (
        <div className="filter-guide-table-header-container">
            <div className="filtered-guide-generic-row">
                <div
                    className="date-text text filtered-guide-left-side-table table-header-category"
                    data-testid="filtered-guide-day-date"
                >
                    {gridHeaderCellDate}
                </div>
                <div
                    className="category-text text filtered-guide-right-side-table table-header-category"
                    data-testid="filtered-guide-category-text"
                >
                    {category.toLocaleUpperCase()}
                </div>
            </div>
        </div>
    );
};

export default FilteredGuideTableHeader;
